
import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    weapon: 'Weapon',
    sticker: 'Sticker',
    graffiti: 'Graffiti',
    case: 'Case',
    capsule: 'Capsule',
    package: 'Package',
    collection: 'Collection',
    musicKit: 'Music kit',
    patch: 'Patch',
    charm: 'Charm',
    agent: 'Agent',
    knife: 'Knife',
    gloves: 'Gloves',
    item: 'Item',
    condition: 'Condition',
    color: 'Color',
  },
  ru: {
    weapon: 'Оружие',
    sticker: 'Стикер',
    graffiti: 'Граффити',
    case: 'Кейс',
    capsule: 'Капсула',
    package: 'Набор',
    collection: 'Коллекция',
    musicKit: 'Музыкальный набор',
    patch: 'Нашивка',
    charm: 'Брелок',
    agent: 'Агент',
    knife: 'Нож',
    gloves: 'Перчатки',
    item: 'Предмет',
    condition: 'Состояние',
    color: 'Цвет',
  },
  uz: {
    weapon: 'Qurol',
    sticker: 'Stiker',
    graffiti: 'Grafitti',
    case: 'Quti',
    capsule: 'Kapsula',
    package: 'Toplam',
    collection: 'Kolleksiya',
    musicKit: 'Musiqa toplami',
    patch: 'Yamoq',
    charm: 'Brelok',
    agent: 'Agent',
    knife: 'Pichoq',
    gloves: 'Qoʻlqop',
    item: 'Buyum',
    condition: 'Holati',
    color: 'Rang',
  },
  fa: {
    weapon: 'سلاح',
    sticker: 'استیکر',
    graffiti: 'گرافیتی',
    case: 'کیس',
    capsule: 'کپسول',
    package: 'بسته',
    collection: 'مجموعه',
    musicKit: 'پک موسیقی',
    patch: 'پچ',
    charm: 'آویز',
    agent: 'ایجنت',
    knife: 'چاقو',
    gloves: 'دستکش',
    item: 'آیتم',
    condition: 'وضعیت',
    color: 'رنگ',
  },
  pt: {
    weapon: 'Arma',
    sticker: 'Adesivo',
    graffiti: 'Grafite',
    case: 'Caixa',
    capsule: 'Cápsula',
    package: 'Pacote',
    collection: 'Coleção',
    musicKit: 'Kit de música',
    patch: 'Emblema',
    charm: 'Chaveiro',
    agent: 'Agente',
    knife: 'Faca',
    gloves: 'Luvas',
    item: 'Item',
    condition: 'Condição',
    color: 'Cor',
  },
  tr: {
    weapon: 'Silah',
    sticker: 'Çıkartma',
    graffiti: 'Grafiti',
    case: 'Kasa',
    capsule: 'Kapsül',
    package: 'Paket',
    collection: 'Koleksiyon',
    musicKit: 'Müzik kiti',
    patch: 'Arma',
    charm: 'Anahtarlık',
    agent: 'Ajan',
    knife: 'Bıçak',
    gloves: 'Eldiven',
    item: 'Eşya',
    condition: 'Durum',
    color: 'Renk',
  },
});
